var map = {
	"./荣誉_01@2x.png": "bbf0",
	"./荣誉_02@2x.png": "bc91",
	"./荣誉_03@2x.png": "5880",
	"./荣誉_04@2x.png": "c7ab",
	"./荣誉_05@2x.png": "e138",
	"./荣誉_06@2x.png": "a275",
	"./荣誉_07@2x.png": "63bf",
	"./荣誉_08@2x.png": "84ea",
	"./荣誉_09@2x.png": "5551",
	"./荣誉_10@2x.png": "1508"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5de9";